import React from 'react';
import styled from 'styled-components';
import useScrollAnimation from '../../hooks/useScrollAnimation';

const AnimatedWrapper = styled.div`
  overflow: hidden;
  position: relative;
  display: block;
  height: 100%;
`;

const AnimatedSection = ({
  children,
  animation = 'fade-in',
  delay = 0,
  duration = 0.5,
  ...props
}) => {
  const ref = useScrollAnimation();

  const mapAnimationName = (name) => {
    switch (name) {
      case 'fadeIn':
      case 'slideUp':
        return 'fade-in';
      case 'fadeInLeft':
        return 'slide-in-left';
      case 'fadeInRight':
        return 'slide-in-right';
      case 'zoomIn':
        return 'scale-in';
      default:
        return name;
    }
  };

  const className = mapAnimationName(animation);

  const style = {
    '--anim-delay': `${delay}s`,
    '--anim-duration': `${duration}s`,
  };

  return (
    <AnimatedWrapper ref={ref} data-animated-section {...props}>
      <div className={`${className}`} style={style}>
        {children}
      </div>
    </AnimatedWrapper>
  );
};

export default AnimatedSection;
